import React, { useEffect, useMemo, useRef, useState } from "react";
import { CalendarDays, Check, ChevronDown, X } from "lucide-react";

const monthLabel = (periode) => `${String(periode.mois).padStart(2, "0")}/${periode.annee}`;

export default function PeriodMultiSelect({ periodes = [], value = [], onChange }) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const selectedIds = useMemo(() => new Set(value.map(String)), [value]);

    useEffect(() => {
        const closeOnOutsideClick = (event) => {
            if (!rootRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener("mousedown", closeOnOutsideClick);
        return () => document.removeEventListener("mousedown", closeOnOutsideClick);
    }, []);

    const selectedPeriods = periodes.filter((periode) => selectedIds.has(String(periode.id)));
    const selectionLabel = selectedPeriods.length === 0
        ? "Toutes les périodes"
        : selectedPeriods.length === 1
            ? monthLabel(selectedPeriods[0])
            : `${selectedPeriods.length} périodes sélectionnées`;

    const togglePeriod = (id) => {
        const key = String(id);
        onChange(selectedIds.has(key)
            ? value.filter((selectedId) => String(selectedId) !== key)
            : [...value, key]);
    };

    return (
        <div className="pcyc-period-picker" ref={rootRef}>
            <span className="pcyc-period-picker-label">Périodes</span>
            <button
                type="button"
                className={`pcyc-period-picker-trigger ${open ? "is-open" : ""}`}
                onClick={() => setOpen((current) => !current)}
                aria-expanded={open}
            >
                <CalendarDays size={16} />
                <span>{selectionLabel}</span>
                {selectedPeriods.length > 1 && <b>{selectedPeriods.length}</b>}
                <ChevronDown size={16} className="pcyc-period-picker-chevron" />
            </button>

            {open && (
                <div className="pcyc-period-picker-menu">
                    <div className="pcyc-period-picker-menu-head">
                        <span>Sélectionner les périodes</span>
                        <button type="button" onClick={() => setOpen(false)} aria-label="Fermer"><X size={15} /></button>
                    </div>
                    <div className="pcyc-period-picker-actions">
                        <button type="button" onClick={() => onChange(periodes.map((periode) => String(periode.id)))}>Tout sélectionner</button>
                        <button type="button" onClick={() => onChange([])}>Effacer</button>
                    </div>
                    <div className="pcyc-period-picker-options">
                        {periodes.map((periode) => {
                            const checked = selectedIds.has(String(periode.id));
                            return (
                                <button
                                    key={periode.id}
                                    type="button"
                                    className={`pcyc-period-picker-option ${checked ? "is-selected" : ""}`}
                                    onClick={() => togglePeriod(periode.id)}
                                >
                                    <span className="pcyc-period-picker-check">{checked && <Check size={13} />}</span>
                                    <span>{monthLabel(periode)}</span>
                                    <small>{periode.statut}</small>
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}
